import React, {Component} from "react";
import {Button, message} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import css from './index.css';
import {hasAuth} from "../../../utils/NHCore";

const basicUrl = '/hjfp/';

/**
 * 环节分配列表
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-17 11:20:04
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {}, //初始数据
            formData:{}, //要新增的数据
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                viewFlag: false,
            }
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }

    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys.length > 0) {
            let yhids = {yhids: selectedRowKeys};
            this.setState({formData: yhids});
            this.setCurrentPageShow('addFlag');
        } else {
            message.warning("请先选择需要分配环节的用户！");

        }
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("确定重置已分配的环节？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("确定重置已选择用户的已分配环节？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            NHConfirm("未选中用户！是否重置所有用户的已分配环节？", () => {
                this.handleDelete(['-1']);
            }, "danger");
        }
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("重置成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validate((selectedRowKeys) => {
            console.info(formData);
            const formData = this.state.formData;
            formData.lchjid = selectedRowKeys;
            NHFetch(basicUrl + 'insert', 'POST', formData)
                .then(res => {
                    if (res) {
                        message.success("分配环节成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '用户账户',
                width: '60px',
                dataIndex: 'GH',
                searchType:"input"
            }, {
                title: '用户姓名',
                width: '60px',
                dataIndex: 'XM',
                searchType:"input"
            }, {
                title: '已分配环节',
                width: '200px',
                dataIndex: 'HJMC',
                render: (text, record) => {
                    if (text != null && text != '') {
                        const lchj = text.split(';');
                        for (let key in lchj) {
                            lchj[key] = <p className={css["tablecell-p-text"]} style={{marginTop: key > 0 ? 5:0}}> {lchj[key]}</p>;
                        }
                        return <div>{[...lchj]}</div>;
                    } else {
                        return null;
                    }
                },
                searchType:"input"
            }, {
                title: '所属部门',
                width: '80px',
                dataIndex: 'BMMC',
                searchType:"input"
            }
        ];
        //行内操作
        const action = [
            {title: '重置', onClick: this.handleSingleDeleteBtnClick, auth:'zhxg_yxgl_lcgl_hjfp:reset'}
        ];
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxxt_lcgl_hjfp_queryPage"}
                             columns={columns}
                             action={action}
                    >
                        {
                            hasAuth('zhxg_yxgl_lcgl_hjfp:add')?
                                <Button type="primary" onClick={this.handleAddBtnClick}>分配环节</Button>
                                :null
                        }
                        {
                            hasAuth('zhxg_yxgl_lcgl_hjfp:reset')?
                                <Button type="primary" ghost style={{marginLeft: 10}}
                                        onClick={this.handleMultiDeleteBtnClick}>重置</Button>
                                :null
                        }

                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                                  title="分配迎新现场环节"
                                  visible={this.state.frameVisibleMap.addFlag}
                                  onOk={this.handleSaveAdd}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm"/>
                </NHContainerFrame>
            </div>
        );
    }
}

export default IndexComponent;



// WEBPACK FOOTER //
// ./components/lcgl/hjfp/index.js